import React from 'react';

const Footer = () => {
    return (
        <footer className="ftco-footer ftco-section">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-md">
                        <div className="ftco-footer-widget mb-4">
                            <h2 className="ftco-heading-2">About</h2>
                            <p>
                                Dedicated and performance-focused developer with 5 years of professional experience
                                delivering scalable web applications and enterprise solutions.
                                Committed to clean architecture, efficient code practices, and continuous technical growth.
                            </p>
                            <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
                                {/* <li className="ftco-animate" data-aos="fade-up"><a href="#"><span className="icon-twitter"></span></a></li> */}
                                <li className="ftco-animate" data-aos="fade-up" data-aos-delay="100"><a href="https://www.linkedin.com/in/mohammad-sahil-53b678226?utm_source=share_via&utm_content=profile&utm_medium=member_android"><span className="icon-linkedin"></span></a></li>
                                <li className="ftco-animate" data-aos="fade-up" data-aos-delay="200"><a href="https://www.instagram.com/mohammad_sahil_2137?igsh=bGMxeDNlcmxkdjAz"><span className="icon-instagram"></span></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="ftco-footer-widget mb-4 ml-md-4">
                            <h2 className="ftco-heading-2">Links</h2>
                            <ul className="list-unstyled">
                                <li><a href="#home-section"><span className="icon-long-arrow-right mr-2"></span>Home</a></li>
                                <li><a href="#about-section"><span className="icon-long-arrow-right mr-2"></span>About</a></li>
                                <li><a href="#resume-section"><span className="icon-long-arrow-right mr-2"></span>Resume</a></li>
                                <li><a href="#services-section"><span className="icon-long-arrow-right mr-2"></span>Services</a></li>
                                <li><a href="#skills-section"><span className="icon-long-arrow-right mr-2"></span>Skills</a></li>
                                <li><a href="#projects-section"><span className="icon-long-arrow-right mr-2"></span>Projects</a></li>
                                <li><a href="#contact-section"><span className="icon-long-arrow-right mr-2"></span>Contact</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="ftco-footer-widget mb-4">
                            <h2 className="ftco-heading-2">Services</h2>
                            <ul className="list-unstyled">
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Web Development</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Full Stack Development</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>API Development</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Real-time Applications</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Payment Integration</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>E-commerce Solutions</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Observability</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>CI/CD Pipelines</a></li>
                                <li><a href="#"><span className="icon-long-arrow-right mr-2"></span>Server Administration & Deployment</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md">
                        <div className="ftco-footer-widget mb-4">
                            <h2 className="ftco-heading-2">Have a Questions?</h2>
                            <div className="block-23 mb-3">
                                <ul>
                                    <li><span className="icon icon-map-marker"></span><span className="text">Sector 21-B, Chandigarh</span></li>
                                    <li><a href="#"><span className="icon icon-phone"></span><span className="text">+91 95924 07801</span></a></li>
                                    <li><a href="#"><span className="icon icon-envelope"></span><span className="text">sahil021mohammad@gmail.com</span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
